(() => {
  'use strict';

  const bar = document.getElementById('adv-mobile-bar');
  const closeBtn = document.getElementById('adv-mobile-bar-close');

  if (bar && closeBtn) {
    closeBtn.addEventListener('click', () => {
      bar.classList.add('is-hidden');
    });

    // Hide the bar once the visitor reaches the final CTA / footer, so it
    // doesn't sit on top of the actual offer section at the bottom of the page.
    const footer = document.querySelector('.adv-footer');
    if (footer && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            bar.classList.toggle('is-hidden', entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -40% 0px' }
      );
      observer.observe(footer);
    }
  }

  // Testimonials carousel: clicking a dot scrolls its card into view, and
  // whichever card is most visible keeps its dot highlighted as the
  // visitor swipes/scrolls through the track by hand.
  const track = document.getElementById('adv-testimonial-track');
  const dotsWrap = document.getElementById('adv-testimonial-dots');
  if (track && dotsWrap) {
    const cards = Array.from(track.querySelectorAll('.adv-testimonial-card'));
    const dots = Array.from(dotsWrap.querySelectorAll('.adv-testimonial-dots__dot'));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.index);
        const card = cards[index];
        if (card) card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = cards.indexOf(entry.target);
            dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          });
        },
        { root: track, threshold: 0.6 }
      );
      cards.forEach((card) => observer.observe(card));
    }
  }
})();
